<section class="relative overflow-hidden py-24 bg-bg-base">
  <!-- Premium background glow effects -->
  <div class="pointer-events-none absolute inset-0 opacity-40">
    <div class="absolute left-1/4 top-0 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-soft blur-[120px]"></div>
    <div class="absolute right-0 bottom-0 h-[600px] w-[600px] translate-x-1/3 translate-y-1/3 rounded-full bg-primary-deep blur-[150px]"></div>
  </div>

  <div class="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="mb-20 text-center">
      <h2 class="h2 mb-4">
        <span class="text-primary">{{ 'home.customersSay.title' | translate }}</span>
      </h2>
      <p class="body-large max-w-2xl mx-auto">{{ 'home.customersSay.subtitle' | translate }}</p>
    </div>

    <!-- The carousel -->
    <app-reviews-carousel [reviews]="reviews" [currentReviewIndex]="currentReviewIndex"></app-reviews-carousel>

    <!-- Stats Grid -->
    <div class="mx-auto mt-24 grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-3">
      <!-- Stat 1 -->
      <div class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center">
        <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <div class="relative z-10 mb-3 text-4xl font-bold tracking-tight text-text-primary group-hover:icon-gradient transition-all duration-300">98%</div>
        <div class="relative z-10 label uppercase tracking-wider text-text-muted">
          {{ 'home.customersSay.stats.satisfaction' | translate }}
        </div>
      </div>
      <!-- Stat 2 -->
      <div class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center">
        <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <div class="relative z-10 mb-3 text-4xl font-bold tracking-tight text-text-primary group-hover:icon-gradient transition-all duration-300">15,000+</div>
        <div class="relative z-10 label uppercase tracking-wider text-text-muted">
          {{ 'home.customersSay.stats.clients' | translate }}
        </div>
      </div>
      <!-- Stat 3 -->
      <div class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center">
        <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <div class="relative z-10 mb-3 text-4xl font-bold tracking-tight text-text-primary group-hover:icon-gradient transition-all duration-300">4.9/5</div>
        <div class="relative z-10 label uppercase tracking-wider text-text-muted">
          {{ 'home.customersSay.stats.rating' | translate }}
        </div>
      </div>
    </div>
  </div>
</section>
